__turbopack_context__.v({
  "edit": "EditButton-module-scss-module__O7VWEG__edit",
  "incomplete": "EditButton-module-scss-module__O7VWEG__incomplete",
  "root": "EditButton-module-scss-module__O7VWEG__root",
});
